module.exports = __webpack_public_path__ + "img/all-secure-ucb-1.37258ba9.svg";